<template>
	<div class="user">
		<div class="user-info">
			<div class="message-box">
				<i title="消息提醒" class="btn-message el-icon-message-solid" @click="goMessage"></i>
				<div class="message-dot" v-if="messageDot"></div>
			</div>
			<el-avatar shape="square">
				<el-image :src="userHeadFile">
					<template #error>
						<el-icon><IEpAvatar /></el-icon>
					</template>
				</el-image>
			</el-avatar>
			<div class="user-name">
				<UserDropdown />
			</div>
		</div>
	</div>
</template>

<script lang="ts">
export default {
	name: 'UserHeader',
}
</script>
<script lang="ts" setup>
import UserDropdown from './UserDropdown.vue'
import { useAppStore } from '@/store/app'
import { getImageUrl } from '@/api/file'
const userHeadFile = computed(() => {
	return getImageUrl(appStore.userInfo.userHeadFile ? appStore.userInfo.userHeadFile[0] : '')
})

const appStore = useAppStore()
const messageDot = ref(false)
const router = useRouter()
function goMessage() {
	router.push({ name: 'message-list' })
}
</script>

<style lang="scss" scoped>
$textColor: #303030;
$profileSize: 32px;
.el-image {
	color: var(--el-color-primary);
	width: 100%;
	height: 100%;
	line-height: $profileSize;
	.el-icon {
		font-size: $profileSize;
	}
}
.user {
	display: flex;
	align-items: center;
	a + a {
		margin-left: 12px;
	}
	&-remind {
		line-height: 1;
		:deep(.iconfont) {
			font-size: 32px;
			color: #a3e6d5;
			cursor: pointer;
		}
	}
	&-todo {
		margin-left: 32px;
		line-height: 1;
		:deep(.iconfont) {
			font-size: 26px;
			color: $textColor;
			cursor: pointer;
		}
	}
	&-info {
		display: flex;
		align-items: center;
		margin-left: 24px;
		.message-box {
			position: relative;
			margin-right: 24px;
			height: 60px;
			line-height: 60px;
			color: #999;
			text-align: center;
			i {
				margin-top: 14px;
				cursor: pointer;
				color: $color-white;
				font-size: 32px;
			}
			.message-dot {
				position: absolute;
				background-color: #ff2727;
				width: 10px;
				height: 10px;
				border-radius: 50%;
				top: 12px;
				right: -2px;
			}
		}
	}
	&-name {
		@include h-v-c;
		margin-left: 8px;
	}

	:deep(.el-image__wrapper) {
		@include h-v-c;
	}
}
</style>
